<template>
    <div class="site">
        <div class="auto">
            <div class="item" v-for="item in site" :key="item.title">
                <a href="#">
                    <img :src="item.src" :alt="item.content" />
                    <div class="mask">
                        <p class="title">{{ item.title }}</p>
                        <p class="content">{{ item.content }}</p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site',
    computed: {
        site() {
            return this.$store.state.site;
        }
    }
};
</script>

<style lang="scss" scoped>
.site {
    .auto {
        display: flex;
        flex-wrap: wrap;
        .item {
            width: calc(100% / 3);
            @media screen and (max-width: 1224px) {
                width: 50%;
            }
            @media screen and (max-width: 640px) {
                width: 100%;
            }
            a {
                display: inline-block;
                position: relative;
                img {
                    width: 100%;
                    vertical-align: middle;
                }
                .mask {
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    opacity: 0;
                    height: 100%;
                    width: 100%;
                    color: white;
                    background-color: $green;
                    text-align: center;
                    line-height: 32px;
                    transition: 0.4s;
                }
            }
            &:hover {
                a {
                    .mask {
                        opacity: 0.7;
                    }
                }
            }
        }
    }
}
</style>